import { render, staticRenderFns } from "./VueMenu.vue?vue&type=template&id=a7b2e1f6&scoped=true&"
import script from "./VueMenu.vue?vue&type=script&lang=js&"
export * from "./VueMenu.vue?vue&type=script&lang=js&"
import style0 from "./VueMenu.vue?vue&type=style&index=0&id=a7b2e1f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b2e1f6",
  null
  
)

export default component.exports